import { useSelector } from 'react-redux'
import { selectUserStatus } from 'root-redux/selects/user'
import { Cohort } from 'root-constants'
import { selectCurrentVariantCohort } from 'root-redux/selects/common'
import { PageId, PURCHASE_PAGES_MAP } from 'page-constants'

export const useUserStatus = (): string => {
  const userStatus = useSelector(selectUserStatus)
  const cohort = useSelector(selectCurrentVariantCohort)

  if (userStatus?.account.hasAccount) {
    return PageId.DOWNLOAD
  }

  if (userStatus?.hasSubscription) {
    return PageId.DOWNLOAD
  }

  if (userStatus?.email.hasEmail) {
    return PURCHASE_PAGES_MAP[cohort as Cohort]
  }

  return ''
}
